import Vue from 'vue';
import VueRouter from 'vue-router';
import RouterComponent from '@/components/RouterComponent.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "start" */ '../views/main/Start.vue'),
    children: [
      {
        path: 'login',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
      },
      {
        path: 'main',
        component: () => import(/* webpackChunkName: "main" */ '../views/main/Main.vue'),
        children: [
          {
            path: 'dashboard',
            component: () => import(/* webpackChunkName: "main-dashboard" */ '../views/main/Dashboard.vue'),
          },
          {
            path: 'profile',
            component: RouterComponent,
            redirect: 'profile/view',
            children: [
              {
                path: 'view',
                component: () => import(/* webpackChunkName: "main-profile" */ '../views/main/profile/UserProfile.vue'),
              },
              {
                path: 'edit',
                component: () =>
                  import(/* webpackChunkName: "main-profile-edit" */ '../views/main/profile/UserProfileEdit.vue'),
              },
              {
                path: 'password',
                component: () =>
                  import(/* "main-profile-password" */ '../views/main/profile/UserProfileEditPassword.vue'),
              },
            ],
          },
          {
            path: 'messages',
            component: RouterComponent,
            redirect: 'messages/all',
            children: [
              {
                path: 'statistics',
                name: 'main-messages-statistics',
                component: () => import('../views/main/message/MessagesStatistics.vue'),
              },
              {
                path: 'send',
                name: 'main-messages-send',
                component: () => import('../views/main/message/SendMessage.vue'),
              },
              {
                path: 'all',
                component: () => import('../views/main/message/Messages.vue'),
              },
            ],
          },
          {
            path: 'admin',
            component: () => import(/* webpackChunkName: "main-admin" */ '../views/main/admin/Admin.vue'),
            redirect: 'admin/users/all',
            children: [
              {
                path: 'users',
                redirect: 'users/all',
              },
              {
                path: 'users/all',
                component: () => import('../views/main/admin/AdminUsers.vue'),
              },
              {
                path: 'users/edit/:id',
                name: 'main-admin-users-edit',
                component: () =>
                  import(/* webpackChunkName: "main-admin-users-edit" */ '../views/main/admin/EditUser.vue'),
              },
              {
                path: 'users/create',
                name: 'main-admin-users-create',
                component: () =>
                  import(/* webpackChunkName: "main-admin-users-create" */ '../views/main/admin/CreateUser.vue'),
              },
              {
                path: 'services',
                redirect: 'services/all',
              },
              {
                path: 'services/all',
                component: () =>
                  import(/* webpackChunkName: "main-admin-services" */ '../views/main/service/Services.vue'),
              },
              {
                path: 'services/create',
                name: 'main-admin-services-create',
                component: () => import(/* "main-admin-services-create" */ '../views/main/service/CreateService.vue'),
              },
              {
                path: 'services/edit/:id',
                name: 'main-admin-services-edit',
                component: () =>
                  import(/* webpackChunkName: "main-admin-services-edit" */ '../views/main/service/EditService.vue'),
              },
              {
                path: 'settings',
                redirect: 'settings/all',
              },
              {
                path: 'settings/all',
                component: () =>
                  import(/* webpackChunkName: "main-admin-services" */ '../views/main/setting/Settings.vue'),
              },
              {
                path: 'mo_sender_bans',
                redirect: 'mo_sender_bans/all',
              },
              {
                path: 'mo_sender_bans/all',
                component: () =>
                  import(/* webpackChunkName: "main-admin-services" */ '../views/main/sender_ban/SenderBans.vue'),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '/*',
    redirect: '/',
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
